import React from 'react';
import styled from 'styled-components';

import { Clock, Flight } from '@lt/components/icons-react';

import { PreviousSearchesOption } from '../../../../../context';
import { convertDatesToStringWithEllipsis } from '../../../../../utils';
import { Template } from './Template';

export const PreviousSearchOption = ({
  destination,
  datepicker,
  departure,
  tourists,
  searchType,
}: PreviousSearchesOption) => {
  const countryName =
    destination?.groupName === 'hotels' || destination?.groupName === 'regions'
      ? `${destination.countryName} `
      : '';

  return (
    <Template
      label={destination?.label || ''}
      stars={destination?.stars || 0}
      icon={<StyledClock />}
    >
      <DescriptionContainer>
        {countryName && <span>{countryName}</span>}
        <DatesBlock>
          <span>{convertDatesToStringWithEllipsis(datepicker?.left, true)}</span>
          <StyledFlight />
          <span>{convertDatesToStringWithEllipsis(datepicker?.right, true)}</span>
        </DatesBlock>
        {searchType === 'package' && <span>из {departure?.selectedLabel}</span>}
        <span>{tourists.adults + tourists.kids.length} чел</span>
      </DescriptionContainer>
    </Template>
  );
};

const StyledClock = styled(Clock)`
  stroke: #919499;
`;

const StyledFlight = styled(Flight)`
  width: 16px;
  height: 16px;
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  // отрицательный для первых элементов, учитывая перенос строк
  margin-left: -8px;

  & > * {
    margin-left: 8px;
  }
`;

const DatesBlock = styled.div`
  display: flex;
  & > * + * {
    margin-left: 4px;
  }
`;
